/**
 * Entrypoint of the automation tab
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var AutomationRouteController = require("automation-controllers/AutomationRouteController");
    var AutomationContextModel = require("automation-models/AutomationContextModel");
    var AutomationController = require("automation-controllers/AutomationController");

    // module definition args are optional, but help with encapsulation
    // I recommend making a macro/template in your editor of choice
    LE.module("LEAutomation", function (LEAutomation, LE, Backbone, Marionette, $, _) {
        //the region that this module will display all its views in
        if(LE.sessionManager.hasAutomationAreaFeature()){
            //here we add an initializer that will run when this module is initialized by the LE app
            this.addInitializer(function () {
                this.routeController = new AutomationRouteController();
                this.contextModel = new AutomationContextModel();
                this.automationController = new AutomationController();
                LEAutomation.lockReporting = true;
            });

            this.getMainView = function () {
                return this.automationController.getMainView();
            };

            this.getRouteController = function () {
                return this.routeController;
            };

            this.showLoader = function(options) {
                this.automationController.showLoader(options);
            };

            this.closeLoader = function() {
                this.automationController.closeLoader();
            };
        }
    });

    return LE.module("LEAutomation");
});
